<script setup lang="ts">
import { toRefs } from 'vue';

interface Props {
  students?: Student[];
}

interface Student {
  id: number;
  display_name: string;
}

const props = defineProps<Props>();

const { students } = toRefs(props);

const sorted = (arr: { id: number; display_name: string }[]) => {
  if (arr.length > 1) {
    const sortedList = arr.sort((a, b) => {
      const stringA = a.display_name;
      const stringB = b.display_name;
      if (stringA && stringB) return stringA.localeCompare(stringB);
      else return 1;
    });

    return sortedList;
  } else return arr;
};
</script>

<template>
  <div
    v-for="student in sorted(students as Student[])"
    :key="student.id"
    class="student border-none border-bottom-1 align-content-center flex p-3 w-full"
  >
    <RouterLink :to="`/user/${student.id}`" class="font-semibold" v-text="student.display_name" />
  </div>
</template>

<style lang="scss">
.student {
  border-color: #f1f3f3;
}
</style>
